<template>
    <div class="flex min-w-64 flex-col items-end justify-start">
        <p class="text-xs text-gray-900">
            {{ t('created') }}:
            <strong class="mx-1">
                {{ item.createdBy }}
            </strong>
            <time :datetime="item.created">
                {{ $dayjs(item.created).format('D. M. YYYY HH:mm') }}
            </time>
        </p>
        <p
            v-if="item.updated"
            class="text-xs text-gray-900"
        >
            {{ t('updated') }}:
            <strong class="mx-1">
                {{ item.updatedBy }}
            </strong>
            <time :datetime="item.updated">
                {{ $dayjs(item.updated).format('D. M. YYYY HH:mm') }}
            </time>
        </p>
    </div>
</template>

<script setup>
defineExpose({
    name: 'AuditInfo',
});

const props = defineProps({
    item: {
        type: Object,
        required: true,
    },
});

const item = props.item;
</script>
